const curbsidePickupCheckin = require('services/api/notifications/curbsidePickupCheckin');
const smsSubscribe = require('services/api/notifications/smsSubscribe');

module.exports = {
    curbsidePickupCheckin,
    smsSubscribe
};
